// generated from 27_368 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const randomNumberFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("random_number_filter"),
  comparison_key: z.enum([
    "3", // 15_110 (55.21%)
    "5", // 8_770 (32.04%)
    "4", // 1_763 (6.44%)
    "6", // 1_515 (5.54%)
    "1", // 210 (0.77%)
  ]),
  display_name: z.string(),
  // undefined: 15_089 (55.13%), defined 12_279 (44.87%)
  // avg: 3446.59, min: 0, max: 9999
  raw_value: z.int().min(0).optional(),
  // avg: 5551.45, min: 0, max: 9999
  value: z.int().min(0),
  varies_by_app_group: z.literal(false),
});
